<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="home">
        <div class="relative">
           <images></images> 
             
            <div class="absolute top-0 left-0 pt-4 pl-4">
                <texts></texts>  
                <div class="pt-8">
                  <ytb></ytb>    
                </div>
                <div class="pt-16">
                  <pol></pol>    
                </div>
                       
            </div> 
        </div>      
    </div>
</template>

<script>

import images from './aboutimage';
import texts from './abouttext';
import ytb from './aboutyoutube';
import pol from './aboutfiles';

export default{
    data() {
        return {
            // card 1
            

        }
    },
    computed: {
      
    },
    mounted() {

    },
    created() {
      
    },
    components: {
        images,
        texts,
        ytb,
        pol
    }
}
</script>

<style lang="scss">
#home {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 1200px;
        }
    }
}
</style>
